<template>
   <v-card tile>
          <v-toolbar card dark color="orange">
            <v-btn icon @click.native="$emit('close')" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Avaliação da evidência </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click.native="dialog_criterios = true">Adicionar Critério</v-btn>
              <v-btn dark flat :loading="animationaval" @click.native="avaliar()">Salvar Avaliação</v-btn>
              <v-btn dark flat :loading="animationpub" @click.native="avaliarepublicar()">Salvar e Publicar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-container fluid>
              <v-layout row flex>
                <v-flex sm5 md4 xl5>
                  <evidencia style="position: fixed; top: 100px; width:30%;"
                      :moreopts="false"
                      :image = "aluno.profilePic"
                      :evidencia = "evidencia" 
                      />
                </v-flex>
                <v-flex sm7 md8 xl10 class="px-5">
                  <div style="text-align: center; width: 100%;" v-if="waiting">
                    
                  <v-progress-circular indeterminate 
                  align-center
                  :size="50" 
                  style="text-align: center"
                  color="primary" 
                  v-if="waiting"
                  ></v-progress-circular>
                  </div>
                  <v-card v-for="classif in classificacoes"
                   :key="classif.name">
                   <v-card-title primary-title 
                   :class="corTitulo(classif.name)"
                   >
                  {{classif.name}}
                   </v-card-title>
                   <v-card-text>

                    <div v-for="grupo in classif.grupos" :key="grupo.name">
                    <div class="headline">{{grupo.name}}</div>
                      <div v-for="(subgrupo, index) in grupo.subgrupos" :key="subgrupo.name">

                        <v-subheader class="mb-2"> {{subgrupo.name}} </v-subheader>

                        <v-list three-line
                        v-for="criterio in subgrupo.criterios" :key="criterio.id"
                        >
                        <v-list-tile-content class="pt-2">
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex sm6 style="" class="">
                                <v-header> {{criterio.name}}
                                </v-header>
                                </v-flex>
                                <v-flex sm6 style="text-align: right;" class="" justify-end>
                                  <rate :length="4"
                                  v-model="criterio.valor"
                                  :ratedesc="[criterio.rubrica_1.description, 
                                  criterio.rubrica_2.description, 
                                  criterio.rubrica_3.description, 
                                  criterio.rubrica_4.description]"
                                  @after-rate="rated(criterio)"
                                  />
                                </v-flex>

                              </v-layout>
                            </v-container>

                          <v-list-tile-sub-title v-if="criterio.valor">
                          <v-container fluid>
                          <v-layout row wrap>
                            <v-flex sm12>
                              <v-text-field class="mt-0"
                                name="comentario"
                                label="Comentário"
                                v-model="criterio.comentario"
                                multi-line
                                v-show="criterio.valor"
                                @change="commented(criterio)"
                                :rows="3"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          </v-container>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        </v-list>

                        <v-divider v-if="index != grupo.subgrupos.length -1"></v-divider>
                      </div>
                    </div>
                   </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>

          <!-- Criterios -->
          <v-dialog v-model="dialog_criterios" >
              <input-criterios-aval 
              :criterios="criterios"
              @saved="criteriosSelecionados"
              @scrool="showing">
              </input-criterios-aval>
          </v-dialog>
              <v-snackbar
                :timeout="2000"
                color="success"
                v-model="snackbar"
              >
                Avaliado com Sucesso!
              </v-snackbar>
        </v-card>
</template>

<script>
import api from '@/api'
import Evidencia from '@/components/reusable/evidencia.vue'
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue'
import Rate from '@/components/reusable/Rate.vue'
// import * as easings from 'vuetify/es5/util/easing-patterns'

export default {
  components: {
    Evidencia,
    Rate,
    InputCriteriosAval
  },
  props: {
    evidencia: {},
    aluno: {}

  },
  data () {
    return {
      dialog_criterios: false,
      animationaval: false,
      animationpub: false,
      criterios: [],
      classificacoes: [],
      waiting: false,
      aval_post: [],
      snackbar: false,
      criterios_selecionados: [],
      links: {}
    }
  },
  mounted () {
    this.waiting = true
    api.request('GET', 'criterioavaliado/?aluno=' +
                      this.aluno.id +
                      '&evidencia=' +
                      this.evidencia.id).then(response => {
                        this.waiting = false
                        this.criterios = response.data.results
                        this.links = response.data.links
                        this.getMore()
                        this.filtraAvaliados()
                        if (!(this.evidencia.status === 'F' || this.evidencia.status === 'A')) {
                          this.dialog_criterios = true
                        }
                      })
  },
  methods: {
    getMore () {
      if (this.links.next) {
        this.waiting = true
        api.request('GET', this.links.next).then(response => {
          this.waiting = false
          this.criterios.concat(response.data.results)
          this.links = response.data.links
          this.filtraAvaliados()
          if (this.links.next) {
            this.getMore()
          }
        })
      }
    },
    filtraAvaliados () {
      var avaliados = this.criterios.filter(criterio => {
        return criterio.newest != null
      })
      avaliados.forEach(val => {
        var newval = {
          ...val,
          valor: val.newest.valor,
          comentario: val.newest.comentario
        }
        this.criterios_selecionados.push(newval)
        this.criteriosSelecionados(this.criterios_selecionados)
      })
    },
    showing () {
      this.$nextTick(this.$refs.um.focus)
    },
    avaliar () {
      this.animationaval = true
      api.request('POST', 'avaliacao/', this.aval_post).then(response => {
        this.snackbar = true
        api.request('GET', 'evidencias/' + this.evidencia.id + '/').then(response => {
          this.evidencia = response.data
          this.$emit('avaliado', this.evidencia)
          this.animationaval = false
        }
        )
      })
      this.animationaval = false
      return false
    },
    avaliarepublicar () {
      this.animationpub = true
      var status = 'F'
      api.request('POST', 'avaliacao/', this.aval_post).then(response => {
        api.request('PATCH', 'evidencias/' + this.evidencia.id + '/', {
          status: status
        }).then(response => {
          this.snackbar = true
          this.animationpub = false
        })
      })
      this.animationpub = false
      return false
    },
    corTitulo (name) {
      if (name.toLowerCase() === 'mundo') {
        return 'mundo'
      } else if (name.toLowerCase() === 'indivíduo') {
        return 'individuo'
      } else if (name.toLowerCase() === 'sociedade') {
        return 'sociedade'
      } else {
        return ''
      }
    },
    commented (criterio) {
      var postados = this.aval_post.filter(aval => {
        return aval.criterio === criterio.id
      })
      if (postados.length <= 0) {
        this.aval_post.push(
          {
            valor: criterio.valor,
            comentario: criterio.comentario,
            aluno: this.aluno.id,
            mediador: this.$store.state.user.id,
            evidencia: this.evidencia.id,
            criterio_pk: criterio.id
          }
        )
      } else {
        postados[0].comentario = criterio.comentario
      }
    },
    rated (criterio) {
      var avaliados = this.aval_post.filter(aval => {
        return aval.criterio === criterio.id
      })
      if (avaliados.length <= 0) {
        this.aval_post.push(
          {
            valor: criterio.valor,
            comentario: '',
            aluno: this.aluno.id,
            mediador: this.$store.state.user.id,
            evidencia: this.evidencia.id,
            criterio_pk: criterio.id
          }
        )
      } else {
        avaliados[0].valor = criterio.valor
      }
    },
    criteriosSelecionados (value) {
      this.dialog_criterios = false
      this.criterios_selecionados = value
      this.formataCriterios()
      this.criaArrayClassif()
    },
    formataCriterios () {
      function compare (a, b) {
        if (a.classificacao < b.classificacao) {
          return -1
        } else if (a.classificacao > b.classificacao) {
          return 1
        } else {
          if (a.grupo < b.grupo) {
            return -1
          } else if (a.grupo > b.grupo) {
            return 1
          } else {
            if (a.subgrupo < b.subgrupo) {
              return -1
            } else if (a.subgrupo > b.subgrupo) {
              return 1
            } else {
              if (a.name < b.name) {
                return -1
              } else if (a.name > b.name) {
                return 1
              } else {
                return 0
              }
            }
          }
        }
      }

      this.criterios_selecionados.sort(compare)
    },
    criaArrayClassif () {
      this.criterios_selecionados.forEach(crit => {
        var found = this.classificacoes.filter(el => {
          return el.name === crit.classificacao
        })
        if (found.length <= 0) {
          this.classificacoes.push({
            name: crit.classificacao,
            grupos: [
              { name: crit.grupo,
                subgrupos: [
                  {
                    name: crit.subgrupo,
                    criterios: [
                      crit
                    ]
                  }
                ]}
            ]
          })
        } else {
          var found2 = found[0].grupos.filter(el => {
            return el.name === crit.grupo
          })
          if (found2.length <= 0) {
            found[0].grupos.push({
              name: crit.grupo,
              subgrupos: [
                {
                  name: crit.subgrupo,
                  criterios: [
                    crit
                  ]
                }
              ]

            })
          } else {
            var found3 = found2[0].subgrupos.filter(el => {
              return el.name === crit.subgrupo
            })
            if (found3.length <= 0) {
              found2[0].subgrupos.push(
                {
                  name: crit.subgrupo,
                  criterios: [
                    crit
                  ]
                }
              )
            } else {
              var found4 = found3[0].criterios.filter(el => {
                return el.name === crit.name
              })
              if (found4.length <= 0) {
                found3[0].criterios.push(
                    crit
                )
              } else {

              }
            }
          }
        }
      })
    }

  }
}
</script>
<style lang="css" scoped>
.individuo{
  background-color: #006EFF;
  color: #fff;
}
.sociedade{
  background-color: #FF3B41;
  color: #fff;
}
.mundo{
  background-color: #39DF18;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/reusable/AvalDialogContent.vue